import styles from "src/styles/agGridCustom.module.scss";
import empty from "is-empty";

export const defaultColDef = {
    resizable: false,
    sortable: true,
    filter: false,
    suppressMovable: true,
};

export const getRowClass = (params) => {
    return params.data.isNew ? "ag-row-unsaved" : "";
};

const formatUnixTimestamp = (value) => {
    if (!value) return "";
    const date = new Date(value * 1000);
    return date
        .toLocaleString(undefined, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        })
        .replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$3/$1/$2");
};

const valueFormatter = (params) => {
    if (params.colDef.field === "LastUpdated") {
        return formatUnixTimestamp(params.value);
    }

    return params.value || "-";
};

export const getDetailBlockedSecuritiesListColumnDefs = () => {
    let columns = [
        {
            headerName: "Security Name",
            colId: "Details Security Name",
            field: "Name",
            width: 120,
            minWidth: 120,
            cellClass: [styles.agLeftAlign, styles.agListDetail],
            headerClass: styles.agHeaderLeftAlign,
            menuTabs: [],
        },
        {
            headerName: "BBG Ticker",
            colId: "Details BBG Ticker",
            field: "BbgTicker",
            width: 80,
            minWidth: 80,
            cellClass: [styles.agCenterAlign, styles.agListDetail],
            headerClass: styles.agHeaderCenterAlign,
            menuTabs: [],
        },
        {
            headerName: "ISIN",
            colId: "Details ISIN",
            field: "Isin",
            width: 100,
            minWidth: 80,
            cellClass: [styles.agCenterAlign, styles.agListDetail],
            headerClass: styles.agHeaderCenterAlign,
            menuTabs: [],
        },
        {
            headerName: "Last Updated",
            colId: "Details Last Updated",
            field: "LastUpdated",
            width: 100,
            minWidth: 120,
            cellClass: [styles.agCenterAlign, styles.agListDetail],
            headerClass: styles.agHeaderCenterAlign,
            menuTabs: [],
            valueFormatter,
        },
        {
            headerName: "User",
            colId: "Details User",
            field: "User",
            width: 100,
            minWidth: 100,
            cellClass: [styles.agCenterAlign, styles.agListDetail],
            headerClass: styles.agHeaderCenterAlign,
            menuTabs: [],
        },
        {
            headerName: "Delete",
            colId: "Details Delete",
            cellRenderer: "deleteButton",
            width: 56,
            minWidth: 56,
            cellClass: [styles.agCenterAlign, styles.agListDetail],
            headerClass: styles.agHeaderCenterAlign,
            menuTabs: [],
            sortable: false,
            suppressCellFlash: true,
        },
    ];
    return columns.filter((col) => !empty(col));
};
